export default __webpack_public_path__ + "static/media/Darkshear.27a2dcf9.jpg";